/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import EmptySpaceFieldValid from "./EmptySpaceFieldValid";
import { Button, OverlayTrigger, Tooltip, Form, Image } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { updateAFSOrderManagementFilter } from "../../redux/actions/adminActions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { WebSocketContext } from "../../App";
import wsSend_request from "../../Api/ws/ws_request";
import SearchIcon from "../../assets/img/table_search_box.png";
import Select from "react-select";
import { customFilterOption } from "../Common/customFilterOption";

const AFSOrderDataTableFilter = ({
  tabName,
  filterType,
  searchType,
  ButtonSet,
  searchdisable,
  buttonvisible,
  ...props
}) => {
  const { websocket } = useContext(WebSocketContext);
  const [CommonSearchUpdate, setCommonSearchUpdate] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const today = new Date();
  const {
    AFSOrderManagmentFilter,
    Regionlistall,
    device_id,
    saleTypeAllList,
    AllDealerFranchiseTypeListAll,
  } = useSelector((state) => state.adminReducers);
  const optionSaleTypeAllList = saleTypeAllList?.map((item, index) => ({
    ...item,
    key: item.id,
    value: item?.id,
    label: item?.sale_type,
  }));
  const FranchiseListOption = AllDealerFranchiseTypeListAll?.list
    ?.filter((elm) => elm?.is_active === true && elm?.parent_id === null)
    ?.map((item, index) => ({
      ...item,
      key: item.id,
      value: item?.id,
      label: `${item?.customer_name} - (${item?.franchise_code})`,
    }));
  const Dispatch = useDispatch();

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px", // Adjust the font size as per your requirement
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "38px", // Adjust the height
      height: "38px",
      border: "0px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "38px",
      padding: "0 8px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "38px",
    }),
  };

  // get all sale type list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "sale_type_list",
      request: {
        limit: 20,
        page_no: 1,
        order_by: "-updated_at",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all region list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "region_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all franchise list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "franchise_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // select limit
  const SelectLimitFct = (e, url) => {
    const filterKey = url;
    if (filterKey) {
      Dispatch(
        updateAFSOrderManagementFilter({
          [filterKey]: {
            UserLimit: e.target.value,
            CurrentPage: 1,
          },
        })
      );
    }
  };

  // clear search box
  const ClearSearchFiled = (url) => {
    const filterKey = url;

    if (filterKey) {
      Dispatch(
        updateAFSOrderManagementFilter({
          [filterKey]: {
            UserSearch: "",
          },
        })
      );
    }
  };

  // clear after delete button hit
  document.addEventListener("keydown", function (event) {
    var keyPressed = event.key;
    if (keyPressed === "Delete") {
      ClearSearchFiled(tabName);
    }
  });

  // common search update state
  const SearchMainOnchange = async (value, url) => {
    if (url === tabName) {
      await setCommonSearchUpdate(value);
    }
  };

  // on enter search
  const onEnterSearch = (e, url) => {
    const code = e.which || e.keyCode;
    if (code === 13) {
      const filterKey = tabName;

      if (filterKey) {
        OnEnterSearch(url);
      }
    }
  };

  // search box
  const OnEnterSearch = (url) => {
    const filterKey = url;

    if (filterKey) {
      Dispatch(
        updateAFSOrderManagementFilter({
          [filterKey]: {
            UserSearch: CommonSearchUpdate,
            CurrentPage: 1,
          },
        })
      );
    }
  };

  useEffect(() => {
    const CurrentSearch =
      AFSOrderManagmentFilter[tabName]?.UserSearch === undefined
        ? ""
        : AFSOrderManagmentFilter[tabName]?.UserSearch;
    setCommonSearchUpdate(CurrentSearch);
  }, [AFSOrderManagmentFilter[tabName]]);

  const selectRegionFunction = (e, tabName) => {
    Dispatch(
      updateAFSOrderManagementFilter({
        [tabName]: {
          SelectRegion: e.target.value,
          CurrentPage: 1,
        },
      })
    );
  };

  // select start date
  const DateStartGet = (date, tabName) => {
    if (date === null) {
      setStartDate("");
      setEndDate("");
      Dispatch(
        updateAFSOrderManagementFilter({
          [tabName]: {
            FromDate: "",
            ToDate: "",
          },
        })
      );
    } else {
      Dispatch(
        updateAFSOrderManagementFilter({
          [tabName]: {
            FromDate: date,
            ToDate: "",
          },
        })
      );
      let selectedDate = new Date(date);
      if (selectedDate.toDateString() === today.toDateString()) {
        setStartDate(selectedDate);
        setEndDate(selectedDate);
      } else if (selectedDate < today) {
        let timeDiff = today.getTime() - selectedDate.getTime();
        let daysDiff = Math.round(timeDiff / (1000 * 3600 * 24));
        if (daysDiff >= 15) {
          const fifteenDaysLater = new Date(
            selectedDate.getTime() + 14 * 24 * 60 * 60 * 1000
          );
          setStartDate(selectedDate);
          setEndDate(fifteenDaysLater);
        } else {
          setStartDate(selectedDate);
          setEndDate(today);
        }
      }
    }
  };

  // select end date
  const DateEndGet = (date, tabName) => {
    Dispatch(
      updateAFSOrderManagementFilter({
        [tabName]: {
          CurrentPage: 1,
        },
      })
    );
    if (date === null) {
      // setEndDate("")
      Dispatch(
        updateAFSOrderManagementFilter({
          [tabName]: {
            ToDate: "",
          },
        })
      );
    } else {
      const startDateLimit = new Date(startDate);
      const maxEndDate = new Date(
        startDateLimit.getTime() + 14 * 24 * 60 * 60 * 1000
      ); // 15 days range limit
      if (date > maxEndDate) {
        setEndDate(maxEndDate);
        Dispatch(
          updateAFSOrderManagementFilter({
            [tabName]: {
              ToDate: maxEndDate,
            },
          })
        );
      } else {
        setEndDate(date);
        Dispatch(
          updateAFSOrderManagementFilter({
            [tabName]: {
              ToDate: date,
            },
          })
        );
      }
    }
  };

  // warranty order
  const OnChangeWarrantyOrder = (event, tabName) => {
    Dispatch(
      updateAFSOrderManagementFilter({
        [tabName]: {
          is_warranty_order: event?.target?.value,
          CurrentPage: 1,
        },
      })
    );
  };

  // all order status change
  const OnChangeStatusOrder = (event, tabName) => {
    Dispatch(
      updateAFSOrderManagementFilter({
        [tabName]: {
          Status: event?.target?.value,
          CurrentPage: 1,
        },
      })
    );
  };

  // franchise filter
  const FranchiseSelect = (value) => {
    if (value === null || value === undefined) {
      Dispatch(
        updateAFSOrderManagementFilter({
          [tabName]: {
            Franchise: "",
            CurrentPage: 1,
          },
        })
      );
    } else {
      Dispatch(
        updateAFSOrderManagementFilter({
          [tabName]: {
            Franchise: value,
            CurrentPage: 1,
          },
        })
      );
    }
  };

  // get page limit from redux
  const GetuserLimit = () => {
    if (AFSOrderManagmentFilter[tabName]?.UserLimit === undefined) {
      return 10;
    } else {
      return AFSOrderManagmentFilter[tabName].UserLimit;
    }
  };

  return (
    <React.Fragment>
      <div
        className="filtr_Form quotations_filtr_Form"
        style={{
          paddingBottom: "10px",
          borderBottom: "1px solid #eee",
          marginBottom: "10px",
        }}
      >
        <div className="formloginset afsorderfilter">
          <div className="row">
            <div className="col-md-3" style={{ width: "16%" }}>
              <Form.Group>
                <div className="datepickField min">
                  <DatePicker
                    selected={
                      AFSOrderManagmentFilter[tabName]?.FromDate === "" ||
                      AFSOrderManagmentFilter[tabName]?.FromDate === undefined
                        ? ""
                        : new Date(AFSOrderManagmentFilter[tabName]?.FromDate)
                    }
                    startDate={
                      AFSOrderManagmentFilter[tabName]?.FromDate === "" ||
                      AFSOrderManagmentFilter[tabName]?.FromDate === undefined
                        ? ""
                        : new Date(AFSOrderManagmentFilter[tabName]?.FromDate)
                    }
                    endDate={
                      AFSOrderManagmentFilter[tabName]?.ToDate === "" ||
                      AFSOrderManagmentFilter[tabName]?.ToDate === undefined
                        ? ""
                        : new Date(AFSOrderManagmentFilter[tabName]?.ToDate)
                    }
                    onChange={(date) => DateStartGet(date, tabName)}
                    dateFormat="dd/MM/yyyy"
                    maxDate={today}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Enter From Date"
                    isClearable={
                      AFSOrderManagmentFilter[tabName]?.FromDate === undefined
                        ? false
                        : AFSOrderManagmentFilter[tabName]?.FromDate !== ""
                        ? true
                        : false
                    }
                    name="statDate"
                    autoComplete="off"
                  />
                </div>
              </Form.Group>
            </div>
            <div className="col-md-3" style={{ width: "16%" }}>
              <Form.Group>
                <div className="datepickField">
                  <DatePicker
                    selected={
                      AFSOrderManagmentFilter[tabName]?.ToDate === "" ||
                      AFSOrderManagmentFilter[tabName]?.ToDate === undefined
                        ? ""
                        : new Date(AFSOrderManagmentFilter[tabName]?.ToDate)
                    }
                    startDate={
                      AFSOrderManagmentFilter[tabName]?.FromDate === "" ||
                      AFSOrderManagmentFilter[tabName]?.FromDate === undefined
                        ? ""
                        : new Date(AFSOrderManagmentFilter[tabName]?.FromDate)
                    }
                    endDate={
                      AFSOrderManagmentFilter[tabName]?.ToDate === "" ||
                      AFSOrderManagmentFilter[tabName]?.ToDate === undefined
                        ? ""
                        : new Date(AFSOrderManagmentFilter[tabName]?.ToDate)
                    }
                    minDate={startDate}
                    maxDate={endDate}
                    onChange={(date) => DateEndGet(date, tabName)}
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Enter To Date"
                    isClearable={
                      AFSOrderManagmentFilter[tabName]?.ToDate === undefined
                        ? false
                        : AFSOrderManagmentFilter[tabName]?.ToDate !== ""
                        ? true
                        : false
                    }
                    name="ToDate"
                    autoComplete="off"
                  />
                </div>
              </Form.Group>
            </div>
            <div className="col-md-3" style={{ width: "15%" }}>
              <select
                className="form-control activestatusselet pe-4"
                id="columnfullwith"
                value={AFSOrderManagmentFilter[tabName]?.SelectRegion}
                onChange={(e) => selectRegionFunction(e, tabName)}
              >
                <option value="">Select Region</option>
                {Regionlistall?.filter((elz) => elz?.is_active)?.map(
                  (elm, index) => {
                    return (
                      <option value={elm?.id} key={index}>
                        {elm?.region_name}
                      </option>
                    );
                  }
                )}
              </select>
            </div>
            <div className="col-md-3 labelAddOnFields" style={{ width: "12%" }}>
              <small>Seller Type</small>
              <select
                className="form-control activestatusselet pe-4"
                id="columnfullwith"
                value={AFSOrderManagmentFilter[tabName]?.is_warranty_order}
                onChange={(e) => OnChangeWarrantyOrder(e, tabName)}
              >
                <option value="">All Orders</option>
                {optionSaleTypeAllList?.map((elm, index) => {
                  return (
                    <option value={elm?.id} key={index}>
                      {elm?.sale_type}
                    </option>
                  );
                })}
              </select>
            </div>
            {tabName === "all_afs_orders" && (
              <div
                className="col-md-3 labelAddOnFields"
                style={{ width: "16%" }}
              >
                <small>Order Status</small>
                <select
                  className="form-control activestatusselet pe-4"
                  id="columnfullwith"
                  value={AFSOrderManagmentFilter[tabName]?.Status}
                  onChange={(e) => OnChangeStatusOrder(e, tabName)}
                >
                  <option value="OPEN,INVOICE_PENDING,DISPATCH_PENDING,DISPATCHED,DELIVERED,CANCELLED,RETURN,SO_HALF_APPROVAL,DRAFT">
                    All Orders
                  </option>
                  <option value="OPEN,INVOICE_PENDING,SO_HALF_APPROVAL">
                    Pending Invoicing
                  </option>
                  <option value="DISPATCH_PENDING">Pending Dispatch</option>
                  <option value="DISPATCHED">Pending Delivery</option>
                  <option value="DELIVERED">Delivered</option>
                  <option value="CANCELLED">Cancelled</option>
                  <option value="RETURN">Returned</option>
                  <option value="SO_HALF_APPROVAL">SO Half Approval</option>
                  <option value="DRAFT,RENEW">Draft</option>
                </select>
              </div>
            )}
            <div className="col-md-2" style={{ width: "20%" }}>
              <div
                className="selectMultiselect selectMultiselectBrand"
                id="selectMultiselectBrand"
              >
                <Select
                  value={
                    AFSOrderManagmentFilter[tabName]?.Franchise
                      ? AFSOrderManagmentFilter[tabName]?.Franchise
                      : null
                  }
                  onChange={(e) => FranchiseSelect(e)}
                  isClearable
                  options={FranchiseListOption}
                  className="godown-select-container"
                  classNamePrefix="godown-select"
                  placeholder="Select Franchise"
                  styles={customStyles}
                  filterOption={customFilterOption}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-header-New">
        {searchdisable && (
          <div
            className={`searchBoxwithbtn ${
              CommonSearchUpdate !== "" ? "search" : ""
            }`}
          >
            <input
              type="text"
              className="form-control"
              value={CommonSearchUpdate}
              onKeyDown={(e) => {
                onEnterSearch(e, tabName);
                EmptySpaceFieldValid(e);
              }}
              onChange={(e) => SearchMainOnchange(e.target.value, tabName)}
              placeholder={`Search ${filterType} ...`}
            />
            <Button
              className="searchbtn"
              onClick={() => OnEnterSearch(tabName)}
            >
              <Image src={SearchIcon} alt="search_btn" />
            </Button>
            {CommonSearchUpdate !== "" && (
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 100 }}
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="button-tooltip"
                    {...props}
                  >
                    Clear the search by using the delete key.
                  </Tooltip>
                }
              >
                <i
                  className="bi bi-x-circle-fill searchclear"
                  onClick={() => ClearSearchFiled(tabName)}
                ></i>
              </OverlayTrigger>
            )}

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 100 }}
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="button-tooltip"
                  {...props}
                >
                  Search using {searchType ? `(${searchType})` : ""}
                </Tooltip>
              }
            >
              <i className="searchInfo bi bi-info-circle-fill"></i>
            </OverlayTrigger>
          </div>
        )}
        <div className="card-header-right">
          <select
            className="form-control userLimitselect"
            value={GetuserLimit()}
            onChange={(e) => SelectLimitFct(e, tabName)}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
            <option value="60">60</option>
            <option value="70">70</option>
            <option value="80">80</option>
            <option value="90">90</option>
            <option value="100">100</option>
          </select>
          {buttonvisible && (
            <button
              className="btn head_cmn_btn"
              style={{ marginLeft: filterType === "Users" ? "10px" : "0px" }}
              onClick={ButtonSet?.function}
            >
              <i
                className={
                  ButtonSet?.buttontitle === "Return & Replace"
                    ? "bi bi-arrow-return-right"
                    : "bi bi-plus-circle"
                }
              ></i>
              {ButtonSet?.buttontitle}
            </button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AFSOrderDataTableFilter;

